var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.h1)?_c('h1',{staticClass:"m-0 text-dark",domProps:{"innerHTML":_vm._s(_vm.h1)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }